import {PureComponent} from 'react'
import Phone from 'react-feather/dist/icons/phone.js'

import conf from '../../conf.js'

export default class ContactUsSmall extends PureComponent {
  render() {
    return (
      <a
        href={`tel:${conf.site.phone}`}
        className={"btn btn-primary btn-sm mx-1 d-lg-none contact-us-small"}
      >
        <Phone/>
      </a>
    )
  }
}
